module.exports = __webpack_public_path__ + "img/thumbnail_SaltwaterCrocodile_j_normal.23db2e37.png";